import Clickable from 'atoms/Clickable/Clickable';
import styled, { css } from 'styled-components';
import { mediaQuery } from 'styles/helper';

interface VideoContentProps {
  $vertical?: boolean;
}

const verticalStyles = css`
  max-height: 75vh;
`;

export const VideoContent = styled.div<VideoContentProps>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 111;
  height: fit-content;
  max-height: 56.25vh;
  max-width: 100vw;

  ${({ $vertical }) => $vertical && verticalStyles}
`;

export const CloseButtonContainer = styled(Clickable)`
  position: absolute;
  right: 0px;
  top: -32px;
  cursor: pointer;
`;

interface WistiaContainerProps {
  $vertical?: boolean;
}

const wistiaVerticalStyles = css`
  width: min(400px, 100vw);

  ${mediaQuery(
    'sm',
    css`
      width: 90vw;
    `
  )}
`;

export const WistiaContainer = styled.div<WistiaContainerProps>`
  width: min(900px, 100vw);
  position: relative;

  ${({ $vertical }) => $vertical && wistiaVerticalStyles}
`;
